/**
 * Stable layout viewport for camera choreography.
 *
 * On phones the URL bar collapses and expands while scrolling, so `innerHeight` (and the
 * aspect ratio derived from it) jumps by ~50–120px. Feeding that straight into the camera
 * moves the 3D tower in one visible step. On coarse pointers this keeps the last size and
 * only adopts a new one on a width change or a height change of 160px or more, matching
 * the resize jitter filter in app.ts. Desktop returns the exact size.
 */
const JITTER_PX = 160
// Created once: this runs every frame, and creating a MediaQueryList per call was the hot spot in the profile.
const coarseQuery = typeof window !== 'undefined' ? window.matchMedia('(pointer: coarse)') : null
const isCoarse = (): boolean => coarseQuery?.matches ?? false

let latched = { w: 0, h: 0 }

export function layoutViewport(): { w: number; h: number } {
  const w = window.innerWidth
  const h = window.innerHeight
  if (!isCoarse()) return { w, h }
  if (latched.h === 0 || w !== latched.w || Math.abs(h - latched.h) >= JITTER_PX) {
    latched = { w, h }
  }
  return latched
}
